import React from 'react';

const clubRoleColors = {
  creator: '#7c3aed',
  owner: '#dc2626', 
  manager: '#059669',
};

export default function ClubRoleBadge({ role }) {
  const color = clubRoleColors[role?.toLowerCase()] || '#9ca3af';
  const displayRole = role?.charAt(0).toUpperCase() + role?.slice(1).toLowerCase() || 'Unknown';
  
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '2px 8px',
      borderRadius: '12px',
      background: color,
      color: 'white',
      fontSize: 12,
      fontWeight: 600,
    }}>
      🏢 {displayRole}
    </span>
  );
}
